import $ from 'jquery';
import * as forgotPasswordEvents from '../../tracking/login/forgotPassword';
import * as loginEvents from '../../tracking/login/login';
import * as registerEvents from '../../tracking/login/register';
import { register } from '../../core/bootstrapper';

register('login', function () {
    registerEvents.init();
    loginEvents.init();
    forgotPasswordEvents.init();

    $(document).ready(function () {
        forgotPasswordEvents.executeCookieCallbacks();
    });
});

register(null, function () {
    $(document).ready(function () {
        registerEvents.executeCookieCallbacks();
        loginEvents.executeCookieCallbacks();
    });
});



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/tracking/login/trackingBootstrap.js
 **/